import React from 'react';

const RightContainer: React.FC<{ items: React.ReactNode }> = ({ items }) => {
  return <div className="auth-container__right loaded">{items}</div>;
};

export default RightContainer;
